import React from 'react'
import './style.css'

function Footer() {
    return (
        <footer>
            <p>&copy; Beers Store - 2021 - <a
                href='https://my-links-gabrielduete.vercel.app/' target='_blank' rel="noreferrer"><span>Gabriel Duete</span></a></p>
        </footer>
    )
}

export default Footer